export const SCHEMA_VERSION = '1.0';

export const ANONYMOUS_ID_KEY = 'anonymous_id';
export const ATTRIBUTION_KEY = 'attribution_data';
export const INITIAL_URL_KEY = 'analytics_initial_page_url';
export const INITIAL_REFERRER_KEY = 'analytics_initial_referrer';
export const INITIAL_CAPTURED_KEY = 'analytics_initial_captured';
export const FIRST_PV_FIRED_KEY = 'analytics_first_pv_fired';

export const COOKIE_DOMAIN = '.paygatex.io';
export const COOKIE_MAX_AGE_DAYS = 365;

export const ATTRIBUTION_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'utm_id',
  'gclid',
  'gbraid',
  'wbraid',
  'fbclid',
  'yclid',
  'msclkid',
  'ttclid',
  'twclid',
  'ref',
] as const;

export type AttributionParam = (typeof ATTRIBUTION_PARAMS)[number];

export type UserStatus = 'guest' | 'registered' | 'verified';

export interface TouchData {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;
  utm_id?: string;
  gclid?: string;
  gbraid?: string;
  wbraid?: string;
  fbclid?: string;
  yclid?: string;
  msclkid?: string;
  ttclid?: string;
  twclid?: string;
  ref?: string;
  landing_url?: string;
  referrer?: string;
  timestamp?: number;
  [key: string]: string | number | undefined;
}

export interface StoredAttribution {
  first_touch?: TouchData;
  last_touch?: TouchData;
  first_landing_url?: string;
  last_landing_url?: string;
  first_referrer?: string;
  last_referrer?: string;
}

export interface AnalyticsUser {
  id?: string;
  isEmailVerified?: boolean;
}

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}
